// Public OAuth sign-in page (the api mcp() plugin's `loginPage`). MUST stay a
// single top-level segment: vite builds with base "./", so a deeper path would
// 404 the page's assets (same constraint as /delete-account). __root.tsx
// renders it without AuthGuard. No validateSearch: the provider's signed
// query must reach the server untouched (see lib/oauthFlow.ts).

import { createFileRoute } from '@tanstack/react-router';

import { OAuthSignInPage } from '../components/oauth/OAuthSignInPage';

export const Route = createFileRoute('/oauth-sign-in')({
    component: OAuthSignInPage,
});
